import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import PropTypes from 'prop-types';
import vw from 'src/styles/utils';
import { vwTablet } from 'src/styles/utils';

const Loading = (props) => {
  const { active } = props;
  return (
    <Root style={{ opacity: active ? 1 : 0 }}>
      <img
        src={require('src/assets/images/logo.svg')}
        alt=""
      />
      <h3>Please do not refresh, your submission is being processed</h3>
    </Root>
  );
};

Loading.propTypes = {
  active: PropTypes.bool,
  fullHeight: PropTypes.bool,
};

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
`;

const animate = css`
  animation: ${pulse} 3s infinite ease;
`;

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 110vh;
  z-index: 999;
  background-color: #fff;
  display: flex;
  justify-content: center;
  flex-direction:column;
  pointer-events: none;
  transition: 0.3s ease;
  text-align:center;
  
  img {
    ${vw('width', 110,  203)}
    margin: 0 auto;
    display: block;
    ${animate}
  }
  h3{
   
    display: block;
    font-family: Big Caslon;
    font-weight: normal;
    ${vw('width', 200,  250)}
    ${vw('font-size', 16, 20)}
    ${vw('padding-top', 30,  40)}
    margin: 0 auto;
    }
`;

export default Loading;
